class Action {

    id = null

    constructor(id) {
        this.id = id
    }

    invoke() {
        throw new Error("Not Implemented")
    }
}

export default Action
